import { observer } from 'mobx-react';
import moment from 'moment';
import { localeStore } from 'src/mobx/localesStore';
import Calendar from 'src/view/components/Calendar/Calendar';
import { ICalendarSubmitDate } from 'src/view/components/Calendar/types';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import { defaultPeriodReportFilters, defaultReportsFilters } from 'src/view/screens/ReportsScreen/constants/reprots';
import { salesPeriodStore } from 'src/view/screens/ReportsScreen/screens/SalesPeriod/store/salesPeriodStore';
import { COMPARED_PERIOD } from 'src/view/screens/ReportsScreen/screens/SalesPeriod/types/salesPeriod';
import { reportsStore } from 'src/view/screens/ReportsScreen/store/reportsStore';
import './style.scss';

interface IPeriodComparingOptions {
  period: COMPARED_PERIOD;
  label: string;
}

interface IProps {
  startDate: number;
  endDate: number;
  onlyYears?: boolean;
  periodComparingOptions?: IPeriodComparingOptions[];
  onSelectDate?: () => void;
}

const ReportsCalendar = observer((props: IProps) => {
  const onDateChange = ({ startDate, endDate }: ICalendarSubmitDate) => {
    if (props.onlyYears) {
      salesPeriodStore.setFilters({
        startYearDate: startDate ? moment(startDate).unix() : defaultPeriodReportFilters.startYearDate,
        endYearDate: endDate ? moment(endDate).unix() : defaultPeriodReportFilters.endYearDate,
      });
    } else {
      reportsStore.setFilters({
        startDate: startDate ? moment(startDate).unix() : defaultReportsFilters.startDate,
        endDate: endDate ? moment(endDate).unix() : defaultReportsFilters.endDate,
      });
    }

    if (typeof props.onSelectDate === 'function') {
      props.onSelectDate();
    }
  };

  const onPeriodCompareChange = (comparedPeriod: string | number) => {
    salesPeriodStore.setFilters({ comparedPeriod: comparedPeriod as COMPARED_PERIOD });
  };

  const renderCalendarOption = (option: IPeriodComparingOptions) => (
    <Checkbox
      value={salesPeriodStore.filters.comparedPeriod === option.period}
      name={option.period}
      label={localeStore.t(option.label)}
      onClick={onPeriodCompareChange}
      className="reports-calendar-compares__option"
      inputClassName="family-medium text-size-16 reports-calendar-compares__input"
    />
  );

  return (
    <div className="mr-2">
      <Calendar
        start_date={props.startDate * 1000}
        end_date={props.endDate * 1000}
        changeDate={onDateChange}
        maxDetail={props.onlyYears ? 'decade' : undefined}
        disabledAutoClose
        hideCloseIcon
        type="past"
        fieldClassName="reports-calendar pr-2"
      >
        {props.periodComparingOptions ? (
          <div className="reports-calendar-compares">{props.periodComparingOptions.map(renderCalendarOption)}</div>
        ) : null}
      </Calendar>
    </div>
  );
});

export default ReportsCalendar;
